<div class="container-fluid">

  <rbb-side-menu-headline
    description="Alle aktiven Formulare"
    headline="Formulare"
    icon="fa-solid fa-book"/>

  @if (columns) {
    <rbb-table [columns]="columns" [values]="forms" [tableData]="tableData" [hideColumns]="true" [sort]="true"
               [search]="true" searchType="SEPARATE" [resultNumbers]="true" [additionalNavigationAtTop]="true"/>
    <ng-template let-column="column" let-value="value" #tableData>
      @switch (column.field) {
        @case ('name') {
          <td class="fw-bold">
            {{value[column.field]}}
          </td>
        }
        @case ('createdByLastName') {
          <td>
            {{value.createdByFirstName}} {{value.createdByLastName}}
          </td>
        }
        @case ('timestamp') {
          <td class="small">
            {{ value[column.field] | date:'dd.MM.y HH:mm'}}
          </td>
        }
        @case ('visible') {
          <td class="text-left">
            @if (value[column.field]) {
              <i class="fa-regular fa-eye text-success"></i>
            } @else {
              <i class="fa-regular fa-eye-slash text-danger"></i>
            }
          </td>
        }
        @case ('approvalDataProtectionOfficer') {
          <td>
            @switch (value[column.field]) {
              @case ('APPROVED') {
                <span class="text-success">Ok</span>
              }
              @case ('DECLINED') {
                <span class="text-danger">Abgelehnt</span>
              }
              @case ('PENDING') {
                <span class="text-secondary">Warte auf Freigabe</span>
              }
            }
          </td>
        }
        @case ('showLastOperator') {
          <td class="text-left">
            @if (value[column.field]) {
              <i class="fa-solid fa-check text-success"></i>
            } @else {
              <i class="fa-solid fa-times text-danger"></i>
            }
          </td>
        }
        @case ('allowCancelUntilProgressStarts') {
          <td class="text-left">
            @if (value[column.field]) {
              <i class="fa-solid fa-check text-success"></i>
            } @else {
              <i class="fa-solid fa-times text-danger"></i>
            }
          </td>
        }
        @case ('orderedApprovals') {
          <td class="text-left">
            @if (value[column.field]) {
              <i class="fa-solid fa-check text-success"></i>
            } @else {
              <i class="fa-solid fa-times text-danger"></i>
            }
          </td>
        }
        @case ('fields') {
          <td>
            {{ value[column.field].length }} Felder
          </td>
        }
        @default {
          <td>{{ value[column.field] }}</td>
        }
      }
    </ng-template>
  } @else {
    <rbb-loader/>
  }
</div>
